export default {"src":"/_next/static/media/stressMotivation.585ba43f.svg","height":646,"width":1048,"blurWidth":0,"blurHeight":0};